import { xhr } from '../utils';
import { sortByDeckName } from '../utils';

const ADD_DECK = 'hawaiian-dictionary/decks/ADD_DECK';

const ADD_WORD_TO_DECK = 'hawaiian-dictionary/decks/ADD_WORD_TO_DECK';

const DELETE_DECK = 'hawaiian-dictionary/decks/DELETE_DECK';

const DELETE_WORD_FROM_DECK = 'hawaiian-dictionary/decks/DELETE_WORD_FROM_DECK';

const RESET_FLASHCARD = 'hawaiian-dictionary/decks/RESET_FLASHCARD';

const SET_DECKS = 'hawaiian-dictionary/decks/SET_DECKS';

const SET_SELECTED_DECK = 'hawaiian-dictionary/decks/SET_SELECTED_DECK';

const UPDATE_FLASHCARD_GAME = 'hawaiian-dictionary/decks/UPDATE_FLASHCARD_GAME';

const EDIT_DECK = 'hawaiian-dictionary/decks/EDIT_DECK';

const initialState = {
  items: [],
  selectedDeck: {
    deckId: 0,
    title: '',
    cards: [],
    currentCard: {
      word: '',
      definitions: [],
    },
    correctCount: 0,
    usedCards: [],
    unusedCards: [],
  },
};

export default function reducer(decks = initialState, action = {}) {
  switch (action.type) {
    case ADD_DECK:
      const { newDeck } = action;
      return {
        ...decks,
        items: [...decks.items]
          .concat([
            {
              deckName: newDeck.deckName,
              deckId: newDeck.id,
              cards: [],
            },
          ])
          .sort(sortByDeckName),
      };
    case ADD_WORD_TO_DECK:
      return {
        ...decks,
        items: action.decks,
      };
    case DELETE_DECK:
      const { deletedDeckId } = action;
      return {
        ...decks,
        items: decks.items.filter(obj => {
          return obj.deckId !== deletedDeckId;
        }),
      };
    case DELETE_WORD_FROM_DECK:
      const { updatedDeckId, removedWordId } = action;
      return {
        ...decks,
        items: decks.items.map(deck => {
          if (deck.deckId === updatedDeckId) {
            return {
              ...deck,
              cards: deck.cards.filter(card => card.word_id !== removedWordId),
            };
          }
          return deck;
        }),
      };
    case RESET_FLASHCARD:
      return {
        ...decks,
        selectedDeck: initialState.selectedDeck,
      };
    case SET_DECKS:
      return {
        ...decks,
        items: action.decks,
      };
    case SET_SELECTED_DECK:
      return {
        ...decks,
        selectedDeck: action.selectedDeck,
      };
    case UPDATE_FLASHCARD_GAME:
      return {
        ...decks,
        selectedDeck: action.gameState,
      };
    case EDIT_DECK:
      const { editedDeck } = action;
      return {
        ...decks,
        items: decks.items.map(deck => {
          if (deck.deckId === editedDeck.deckId) {
            const updated = {
              ...deck,
              deckName: editedDeck.deckName,
            };
            return updated;
          }
          return deck;
        }),
      };
    default:
      return decks;
  }
}

export function getDecks(userId) {
  return dispatch => {
    return xhr({ path: `/decks?userId=${userId}` })
      .then(decks => {
        dispatch({ type: SET_DECKS, decks: decks.data.sort(sortByDeckName) });
        return decks.data.sort(sortByDeckName);
      })
      .catch(err => {
        throw err;
      });
  };
}

export function selectDeck(selectedDeck) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_DECK, selectedDeck });
    return selectedDeck;
  };
}

export function updateGameState(gameState) {
  return dispatch => {
    dispatch({ type: UPDATE_FLASHCARD_GAME, gameState });
  };
}

export function resetFlashcardGame() {
  return dispatch => {
    dispatch({ type: RESET_FLASHCARD });
  };
}

export function addDeck(deckName, userId) {
  const body = { deckName, userId };
  return dispatch => {
    return xhr({ path: '/decks', method: 'post', body })
      .then(newDeck => {
        dispatch({ type: ADD_DECK, newDeck });
        return newDeck;
      })
      .catch(err => {
        throw err;
      });
  };
}

export function addWordToDeck(deckId, wordId, decks) {
  const body = { wordId };
  return dispatch => {
    return xhr({ path: `/decks/${deckId}/cards`, method: 'post', body })
      .then(() => {
        let updatedDeck = {};

        const updatedDecks = decks.map(deck => {
          let deckToUpdate = deck;

          if (deck.deckId !== +deckId) {
            return deck;
          }
          deckToUpdate.cards.push({ deckId, word_id: +wordId });
          updatedDeck = deckToUpdate;
          return deckToUpdate;
        });

        dispatch({ type: ADD_WORD_TO_DECK, decks: updatedDecks });
        return updatedDeck;
      })
      .catch(err => {
        throw err;
      });
  };
}

export function deleteDeck(deckId) {
  return dispatch => {
    return xhr({ path: `/decks/${deckId}`, method: 'delete' })
      .then(() => {
        dispatch({ type: DELETE_DECK, deletedDeckId: deckId });
      })
      .catch(err => {
        throw err;
      });
  };
}

export function deleteWordFromDeck(deckId, wordId) {
  return dispatch => {
    return xhr({ path: `/decks/${deckId}/cards/${wordId}`, method: 'delete' })
      .then(updatedDeck => {
        dispatch({
          type: DELETE_WORD_FROM_DECK,
          updatedDeckId: deckId,
          removedWordId: wordId,
        });
      })
      .catch(err => {
        throw err;
      });
  };
}

export function copyDeck(userId, shareId) {
  return dispatch => {
    return xhr({
      path: `/decks/share/${shareId}`,
      method: 'POST',
      body: { userId },
    })
      .then(deck => deck)
      .catch(err => {
        throw err;
      });
  };
}

export function editDeck(payload) {
  const body = {
    deckName: payload.deckName,
  };
  return dispatch => {
    return xhr({ path: `/decks/${payload.id}`, method: 'put', body })
      .then(editedDeck => {
        dispatch({ type: EDIT_DECK, editedDeck });
        return editedDeck;
      })
      .catch(err => err);
  };
}



// WEBPACK FOOTER //
// ./src/redux/decks.js